import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface TooltipSectionProps {
  readonly children: ReactNode;
  /** Add top border (default: false) */
  readonly withBorder?: boolean;
  /** Custom background (default: none) */
  readonly background?: 'gray' | 'white';
  /** Additional className for custom styling */
  readonly className?: string;
}

export const TooltipSection = ({
  children,
  withBorder = false,
  background,
  className,
}: TooltipSectionProps) => {
  return (
    <div
      className={cn(
        'space-y-0.5 p-2 text-xs',
        withBorder && 'border-t border-gray-100',
        background === 'gray' && 'bg-gray-50/50',
        background === 'white' && 'bg-white',
        className,
      )}
    >
      {children}
    </div>
  );
};
